import React, { Component } from 'react';

export default function asyncComponent(importComponent: any): any {
    class AsyncComponent extends Component {
        constructor(props: any) {
            super(props);

            this.state = {
                component: null
            };
        }

        async componentDidMount(): Promise<any> {
            const { default: component } = await importComponent();

            this.setState({
                component
            });
        }

        render(): React.ReactElement | null {
            const { component }: any = this.state;
            const C = component;

            return C ? <C {...this.props} /> : null;
        }
    }

    return AsyncComponent;
}
